import { render, staticRenderFns } from "./politica-privacidade.vue?vue&type=template&id=dd44349c&scoped=true"
import script from "./politica-privacidade.vue?vue&type=script&lang=js"
export * from "./politica-privacidade.vue?vue&type=script&lang=js"
import style0 from "./politica-privacidade.vue?vue&type=style&index=0&id=dd44349c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd44349c",
  null
  
)

export default component.exports